module.exports = __webpack_public_path__ + "static/media/geoffpleiss_research_statement.7e8b199a.pdf";